import { EventEmitter, Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable, Subject } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';
import { StaffDetail } from '../entities/staff-detail';
import { StaffDetailQuery } from '../entities/staff-detatil-query';

@Injectable({
    providedIn: 'root'
})
export class StaffCountService {

    public detailsSelected: EventEmitter<{ companyId: string, year: string, month: string, tipo: string }> = new EventEmitter();
    public detailsAttributeSelected: EventEmitter<{ companyId: string, year: string, month: string, attribute: string, tipo: string }> = new EventEmitter();
    public staffDetail: EventEmitter<{ companyId: string, year: string, month: string, attribute: string, tipo: string }> = new EventEmitter()

    seletedTipo = 0;
    public showDetailPanel = false;
    // private checkOutRooms = new Subject<number>();
    // checkoutRoomsCalled = this.checkOutRooms.asObservable();
    companyStaffObje: StaffDetailQuery;
    public selectedYear: number;

    // need for further development
    // SetCheckOut(_checkinId: number) {
    //     this.checkOutRooms.next(_checkinId);
    // }

    constructor(private _apiService: ApiService) { }



    getEmpresaListByEmpresaId(empresaId: any): Observable<RestResponse> {
        let url = `${API.StaffCount.getEmpresaListByEmpresaId}`;
        url = url.replace('{empresaId}', empresaId.toString());
        return this._apiService.get(url);
    }

    totalizeSelectedCompany(empresaId: any, tabIndex: any): Observable<RestResponse> {
        let url = `${API.StaffCount.totalizeSelectedCompany}`;
        url = url.replace('{empresaId}', empresaId.toString());
        url = url.replace('{tabIndex}', tabIndex.toString());
        return this._apiService.get(url);
    }

    totalizeSelectedCompanySubCompanise(empresaId: any, tabIndex: any): Observable<RestResponse> {
        let url = `${API.StaffCount.totalizeSelectedCompanyAndSubs}`;
        url = url.replace('{empresaId}', empresaId.toString());
        url = url.replace('{tabIndex}', tabIndex.toString());
        return this._apiService.get(url);
    }


    refreshesPlantillaTotalData(): Observable<RestResponse> {
        let url = `${API.StaffCount.refreshesPlantillaTotalData}`;
        return this._apiService.get(url);
    }

    getAttributeListByEmpresaId(id: string): Observable<RestResponse> {
        let url = `${API.StaffCount.getEmployeeAttributeList}`;
        url = url.replace('{id}', id);
        return this._apiService.get(url);
    }

    getCompanyStaffCountByEmpresaId(id: string): Observable<RestResponse> {
        let url = `${API.StaffCount.getCompanyStaffCount}`;
        url = url.replace('{id}', id);
        return this._apiService.get(url);
    }

    getCompanyStaffAttributeCount(id: string, attribuewId: string, year: string): Observable<RestResponse> {
        let url = `${API.StaffCount.getAttributeStaffCount}`;
        url = url.replace('{id}', id);
        url = url.replace('{attributeId}', attribuewId);
        url = url.replace('{year}', year);
        return this._apiService.get(url);
    }

    getAttributeYearList(id: string, attribuewId: string): Observable<RestResponse> {
        let url = `${API.StaffCount.yearsList}`;
        url = url.replace('{id}', id);
        url = url.replace('{attributeId}', attribuewId);
        return this._apiService.get(url);
    }

    updateCompanyStaffCount(companyId: string, year: string, month: string, staffCount: string): Observable<RestResponse> {
        let url = `${API.StaffCount.addUpdateCompanyStaffCount}`;
        url = url.replace('{companyId}', companyId);
        url = url.replace('{year}', year);
        url = url.replace('{month}', month);
        url = url.replace('{staffCount}', staffCount);
        return this._apiService.put(url);
    }

    deleteCompanyStaffCount(companyId: string, year: string, month: string): Observable<RestResponse> {
        let url = `${API.StaffCount.deleteCompanyStaffCount}`;
        url = url.replace('{companyId}', companyId);
        url = url.replace('{year}', year);
        url = url.replace('{month}', month);
        return this._apiService.delete(url);
    }

    updateCompanyAttributeStaffCount(companyId: string, attribute: string, tipo: string, year: string, month: string, staffCount: string): Observable<RestResponse> {
        let url = `${API.StaffCount.addUpdateCompanyAttributeStaffCount}`;
        this.companyStaffObje = new StaffDetailQuery();
        this.companyStaffObje.companyId = companyId;
        this.companyStaffObje.year = year;
        this.companyStaffObje.month = month;
        this.companyStaffObje.attribute = attribute;
        this.companyStaffObje.tipo = tipo;
        this.companyStaffObje.staffCount = staffCount;
        return this._apiService.put(url, this.companyStaffObje);
    }

    deleteCompanyAttributeStaffCount(companyId: string, attribute: string, tipo: string, year: string, month: string): Observable<RestResponse> {
        let url = `${API.StaffCount.deleteCompanyAttributeStaffCount}`;
        url = url.replace('{companyId}', companyId);
        url = url.replace('{attribute}', attribute);
        url = url.replace('{tipo}', tipo);
        url = url.replace('{year}', year);
        url = url.replace('{month}', month);
        return this._apiService.delete(url);
    }

    getStaffCount(companyId: string, year: string, month: string, tipo: string): Observable<RestResponse> {
        let url = `${API.StaffCount.getStaffCount}`;
        url = url.replace('{companyId}', companyId);
        url = url.replace('{year}', year);
        url = url.replace('{month}', month);
        url = url.replace('{tipo}', tipo);
        return this._apiService.get(url);
    }

    isActive(companyId: any){
        let url = `${API.StaffCount.isActive}`;
        url = url.replace('{companyId}', companyId);
        return this._apiService.get(url);
    }

    getStaffAttributeCount(companyId: string, year: string, month: string, attribute: string, tipo: string): Observable<RestResponse> {
        let url = `${API.StaffCount.getStaffAttributeCount}`;
        this.companyStaffObje = new StaffDetailQuery();
        this.companyStaffObje.companyId = companyId;
        this.companyStaffObje.year = year;
        this.companyStaffObje.month = month;
        this.companyStaffObje.attribute = attribute;
        this.companyStaffObje.tipo = tipo;
        return this._apiService.put(url, this.companyStaffObje);
    }

    public updateStaffDetail(staffDetail: StaffDetail): Observable<any> {
        let url = `${API.StaffCount.updateCompanyStaffCount}`;
        return this._apiService.put(url, staffDetail, true);
    }

}
